import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { PendoService } from 'analytics-lib';
import { IRecipientInfoService } from 'recipient-info-service-lib';
import { UtilsService } from 'utils-service-lib';

@Component({
    selector: 'app-popup-dialog',
    templateUrl: './popup-dialog.component.html',
    styleUrls: ['./popup-dialog.component.scss'],
    standalone: false
})
export class PopupDialogComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;
  @Input() namespace;
  @Input() recipients;
  @Input() recipientInfoService: IRecipientInfoService;
  @Input() emailSubject: string;
  @Input() emailBody: string;
  @Input() provider: string;
  @Input() usingDocusignTemplate: boolean;
  @Output() openDialog = new EventEmitter<boolean>();

  constructor(private utilsService: UtilsService, private pendoService: PendoService) {}

  // Keyboard Shortcut
  // - Use Escape to close the popup
  @HostListener('document:keydown', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      this.openDialog.emit(false);
      this.pendoService?.recordEvent('Escape key pressed - to close popup dialog');
    }
  }

  ngOnInit(): void {
    this.utilsService.escapableElementActive(true);
  }

  closePopup(open: boolean): void {
    this.openDialog.emit(open);
  }

  get chromeExtConfigPopupExpanded(): boolean {
    return this.utilsService.chromeExtConfigPopupExpanded;
  }

  ngOnDestroy(): void {
    this.utilsService.escapableElementActive(false);
  }
}
